import { Area, AreaChart, ResponsiveContainer, XAxis, YAxis } from "recharts";

const BlinkIntervalsChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={80}>
    <AreaChart data={data} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
      <XAxis
        dataKey="progress"
        type="number"
        domain={[0, 100]}
        tick={false}
        height={1}
      />
      <YAxis
        dataKey="confidence"
        type="number"
        allowDecimals
        domain={[0, 1]}
        ticks={[0.25, 0.5, 0.75]}
        tickLine={false}
        fontSize={8}
        width={30}
      />
      <Area
        type="step"
        dataKey="confidence"
        stroke="#0E6EA5"
        fill="#0E6EA5"
        fillOpacity={0.3}
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default BlinkIntervalsChart;
